import type { FeedbackMessages } from './en';

const th: FeedbackMessages = {
  qualified: {
    title: 'ขอบคุณที่เข้าร่วมการศึกษานี้จนเสร็จสมบูรณ์!',
    text: 'ท่านสามารถปิดหน้าต่างเบราว์เซอร์ได้\n\nเราหวังว่าจะได้พบท่านอีกในเร็ววันนี้',
  },
  quotaFull: {
    title: 'การศึกษานี้ปิดรับแล้ว',
    text: 'ขอบคุณที่ท่านให้ความสนใจในการศึกษาของเรา\n\nขออภัย เราได้รับคำตอบครบตามจำนวนที่ต้องการแล้ว\n\nเราหวังว่าจะได้พบท่านในการศึกษาครั้งต่อไปของเรา!',
  },
  terminated: {
    title: 'ขอบคุณที่ท่านได้แสดงความคิดเห็น!',
    text: 'เราหวังว่าจะได้พบท่านอีกในการศึกษาครั้งต่อไปของเรา ขอให้ท่านมีวันที่ดีในระหว่างนี้\n\nกรุณาปิดหน้าต่างเบราว์เซอร์นี้',
  },
  mismatch: {
    title: 'ขอบคุณสำหรับความสนใจของท่าน',
    text: 'ขออภัย ท่านไม่อยู่ในกลุ่มเป้าหมายของการศึกษานี้\n\nท่านสามารถปิดหน้านี้ได้',
  },
  error: {
    title: 'เราไม่สามารถดำเนินการตามคำขอของท่านได้',
    linkProblemDetailed:
      'ลิงก์ที่ท่านคลิกมีปัญหา กรุณาตรวจสอบว่าลิงก์ในแถบที่อยู่ตรงกับลิงก์ที่ท่านได้รับ แล้วลองใหม่อีกครั้ง',
    linkProblemGeneric: 'ลิงก์ที่ท่านคลิกมีปัญหา กรุณาลองใหม่อีกครั้ง',
    contactPerson:
      'หากปัญหายังคงเกิดขึ้น กรุณาแจ้งให้ผู้ที่ให้ลิงก์แก่ท่านทราบถึงปัญหานี้',
  },
};

export default th;
